import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=e57f0b8e&"
import script from "./radio-group.vue?vue&type=script&lang=ts&"
export * from "./radio-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e57f0b8e')) {
      api.createRecord('e57f0b8e', component.options)
    } else {
      api.reload('e57f0b8e', component.options)
    }
    module.hot.accept("./radio-group.vue?vue&type=template&id=e57f0b8e&", function () {
      api.rerender('e57f0b8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/question-components/radio-group/radio-group.vue"
export default component.exports